<template>
  <div class="medal-component">
    <div class="medal-img"
         :class="[
           `size-${size}`,
           `status-${status}`
         ]"
         @click="handleClick"
    >
      <ym-img class="img"
              :src="medal"
              :alt="title"
              :lazy="lazy"
      />
    </div>
    <medal-popup :show.sync="showPopup"
                 :title="title"
                 :src="medal"
                 :desc="desc"
    >
    </medal-popup>
  </div>
</template>

<script>
  import MedalPopup from '@/components/MedalPopup';

  export default {
    name: 'Medal',
    components: {
      MedalPopup,
    },
    data() {
      return {
        showPopup: false,
      };
    },
    props: {
      medal: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: '勋章',
      },
      desc: {
        type: String,
        default: '勋章描述',
      },
      status: {
        type: String,
        validator(val) {
          return [
            'uncollected',
            'collected',
          ].includes(val);
        },
        default: 'uncollected',
      },
      lazy: {
        type: Boolean,
      },
      size: {
        type: String,
        validator(val) {
          return [
            'normal',
            'large',
          ].includes(val);
        },
        default: 'normal',
      },
    },
    methods: {
      handleClick() {
        this.showPopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @medal-normal-size: 120px;
  @medal-large-size: 160px;

  .medal-component {
    line-height: 1;
  }

  .medal-img {
    flex-shrink: 0;
    display: inline-block;
    width: @medal-normal-size;
    overflow: hidden;
    &.size-large {
      width: @medal-large-size;
    }
    &.status-uncollected {
      img {
        filter: grayscale(100%);
      }
    }
    .img {
      display: block;
      width: 100%;
    }
  }
</style>
